<template>
  <div class="link">
    <div class="auto_1280">
      <ul class="ul clearfix">
        <li v-for="( item, index ) in linkList" :key="index">
          <a :href="item.intro" target="_blank" rel="nofollow" class="dot">{{item.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Links',
  data () {
    return {
      linkList: [],
      articleTypeId: 37,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  mounted () {
    const self = this
    self.initId()
    self.init()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      self.linkList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 50, bLanguage: this.lan }, r => {
        r.data.forEach((item) => {
          self.linkList.push(item)
        })
      })
    }
  }
}
</script>
<style scoped>
.link{padding-bottom: 5%;}
.link ul{margin: 2% -2%;}
.link li{padding: 0 2%; margin: 1% 0; float: left; width: 20%;}
.link li a{display: block; line-height: 50px; width: 100%; border-radius: 20px 0; color: #fff; font-size: 20px; background-color: rgba(228,0,127,0.7); text-align: center; font-weight: bold; transition: all .3s;}
.link li:hover a{background-color: #e4007f; transform: translateY(-3px); box-shadow: 0px 8px 15px 3px rgba(0, 0, 0, 0.15);}
@media(max-width: 640px){
  .link li{width: 50%;}
}
</style>
